module.exports = __webpack_public_path__ + "static/media/S3P1_result-types.def23290.mp3";